import { UserComponent } from './user.component';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UsersListComponent } from './components/users-list/users-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthorizationModule } from '../../modules/authorization/authorization.module';
import { TableModule } from '../../lib';
import { SharedModule } from '../../modules/shared/shared.module';
import { UserConfigComponent } from './components/user-config/user-config.component';
import { MaterialModule } from '../../modules/material/material.module';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ScopeExtendedComponent } from './components/user-config/scope-extended/scope-extended.component';
import { SharedModule as SharedLibModule } from 'shared-library';

const routes: Routes = [
   { path: '', pathMatch: "full", component: UserComponent },
   { path: 'config', pathMatch: "full", component: UserConfigComponent}
]

@NgModule({
  declarations: [
    UserComponent,
    UsersListComponent,
    UserConfigComponent,
    ScopeExtendedComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    FormsModule,
    TableModule,
    ReactiveFormsModule,
    NgSelectModule,
    AuthorizationModule,
    MaterialModule,
    NgxMatIntlTelInputComponent,
    NgxMatSelectSearchModule,
    SharedLibModule
    
  ],
  exports:[
    UsersListComponent,
    TableModule
  ],
  // entryComponents: [
  //   OtpValidationComponent,
  //   OtpValidationChangePasswordComponent
  // ],
  bootstrap: [UsersListComponent],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class UserModule { }
